import Phaser from 'phaser';
import { LOGICAL_WIDTH, LOGICAL_HEIGHT } from './layout';

// Thunderstorm sequence:
//   1. Whole-screen black overlay fades in (sky goes dark, ~400 ms).
//   2. A small lightning bolt drops in from the top of the screen, camera
//      shakes, and `onMidpoint` fires (used for regrowth).
//   3. Bolt fades; overlay slowly brightens back to clear over ~2 s, then
//      `onComplete` fires.
export function playThunderstorm(
  scene: Phaser.Scene,
  onMidpoint: () => void,
  onComplete: () => void,
): void {
  const overlay = scene.add
    .rectangle(0, 0, LOGICAL_WIDTH, LOGICAL_HEIGHT, 0x000000, 0)
    .setOrigin(0)
    .setDepth(900);

  // Bolt hangs from the top edge. thunderstorm.png is 3114×3855 native
  // (aspect ≈ 0.808). Use a uniform scale so the bolt isn't squished —
  // displaySize would force a non-native aspect ratio.
  const bolt = scene.add
    .image(LOGICAL_WIDTH / 2, 0, 'thunderstorm')
    .setOrigin(0.5, 0)
    .setScale(0.22)
    .setDepth(910)
    .setAlpha(0);

  scene.tweens.add({
    targets: overlay,
    fillAlpha: 0.55,
    duration: 400,
    ease: 'Sine.Out',
    onComplete: () => {
      bolt.setAlpha(1);
      scene.cameras.main.shake(500, 0.012);
      onMidpoint();
      scene.tweens.add({
        targets: bolt,
        alpha: 0,
        duration: 350,
        ease: 'Linear',
      });
      scene.time.delayedCall(400, () => {
        scene.tweens.add({
          targets: overlay,
          fillAlpha: 0,
          duration: 2000,
          ease: 'Sine.InOut',
          onComplete: () => {
            overlay.destroy();
            bolt.destroy();
            onComplete();
          },
        });
      });
    },
  });
}
